import React from "react";
import {
  Card,
  Flex,
  Heading,
  Divider,
  TextField,
  Button,
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  Text,
  View,
  Grid,
  useTheme,
} from "@aws-amplify/ui-react";

import { useUserQuery } from "../../common/useUserQuery";
import { useNavigate } from "react-router-dom";
import { useTodayMentalHealthCheckinQuery } from "../api/mentalHealth/useMentalHealthQuery";
import { useMentalHealthPostMutation } from "../api/mentalHealth/useMentalHealthMutation";

export default function MentalHealthContainer() {
  const { tokens } = useTheme();
  const navigate = useNavigate();
  const { data: userQuery } = useUserQuery();
  const {
    data: mentalHealthTodayQuery,
    isFetching: mentalHealthTodayIsLoading,
  } = useTodayMentalHealthCheckinQuery(userQuery?.patientUserId);

  const {
    mutate: mentalHealthPostMutate,
    isLoading: mentalHealthPostIsLoading,
  } = useMentalHealthPostMutation();
  return (
    <Card variation="elevated">
      <Flex direction={"row"} gap={12}>
        <Heading level={5} children={`Mental Health Check-In`} />
      </Flex>

      <Flex direction={"column"} gap={12} marginTop={12}>
        <Divider size="small" />

        <Grid
          templateColumns={{
            base: "1fr",
            large: "1fr 1fr",
            xl: "1fr 1fr 1fr 1fr",
          }}
          templateRows={{
            base: "repeat(4, 3rem)",
            large: "repeat(2, 3rem)",
            xl: "repeat(1, 3rem)",
          }}
          gap={tokens.space.small}
        >
          {!mentalHealthTodayIsLoading &&
            mentalHealthTodayQuery?.length <= 0 && (
              <>
                <Flex>
                  <Button
                    disabled={mentalHealthPostIsLoading}
                    size="small"
                    grow={1}
                    backgroundColor={"rgba(180,156,250,255)"}
                    onClick={() =>
                      mentalHealthPostMutate({
                        patientUserId: userQuery?.patientUserId,
                        mentalHealthStatus: "GREAT",
                      })
                    }
                  >
                    <Text fontSize={27} marginRight={9}>
                      😊
                    </Text>
                    I’m feeling great
                  </Button>
                </Flex>
                <Flex>
                  <Button
                    disabled={mentalHealthPostIsLoading}
                    size="small"
                    grow={1}
                    backgroundColor={"rgba(157,203,253,255)"}
                    onClick={() =>
                      mentalHealthPostMutate({
                        patientUserId: userQuery?.patientUserId,
                        mentalHealthStatus: "OKEY",
                      })
                    }
                  >
                    <Text fontSize={27} marginRight={9}>
                      😐
                    </Text>{" "}
                    I’m feeling okay
                  </Button>
                </Flex>
                <Flex>
                  <Button
                    disabled={mentalHealthPostIsLoading}
                    size="small"
                    grow={1}
                    backgroundColor={"rgba(252,217,155,255)"}
                    onClick={() =>
                      mentalHealthPostMutate({
                        patientUserId: userQuery?.patientUserId,
                        mentalHealthStatus: "SAD_UPSET",
                      })
                    }
                  >
                    <Text fontSize={27} marginRight={9}>
                      😩
                    </Text>{" "}
                    I’m feeling sad/upset
                  </Button>
                </Flex>
                <Flex>
                  <Button
                    disabled={mentalHealthPostIsLoading}
                    size="small"
                    grow={1}
                    backgroundColor={"rgba(250,155,176,255)"}
                    onClick={() =>
                      mentalHealthPostMutate({
                        patientUserId: userQuery?.patientUserId,
                        mentalHealthStatus: "NEED_HELP",
                      })
                    }
                  >
                    <Text fontSize={27} marginRight={9}>
                      😥
                    </Text>{" "}
                    I am not doing well and need help/support
                  </Button>
                </Flex>
              </>
            )}
          {!mentalHealthTodayIsLoading &&
            mentalHealthTodayQuery?.length > 0 && (
              <Flex
                direction={"column"}
                rowSpan={{ base: 1, large: 2 }}
                columnSpan={[1, 1, 1, 2]}
              >
                <Text>
                  Nice job, you successfuly checked in your mental health today!
                </Text>
                {mentalHealthTodayQuery[0]?.mentalHealthStatus === "GREAT" && (
                  <Flex justifyContent={"flex-start"} alignItems={"center"}>
                    <Text fontSize={27}>😊</Text> I’m feeling great
                  </Flex>
                )}
                {mentalHealthTodayQuery[0]?.mentalHealthStatus === "OKEY" && (
                  <Flex justifyContent={"flex-start"} alignItems={"center"}>
                    <Text fontSize={27}>😐</Text> I’m feeling okay
                  </Flex>
                )}
                {mentalHealthTodayQuery[0]?.mentalHealthStatus ===
                  "SAD_UPSET" && (
                  <Flex justifyContent={"flex-start"} alignItems={"center"}>
                    <Text fontSize={27}>😩</Text> I’m feeling sad/upset
                  </Flex>
                )}
                {mentalHealthTodayQuery[0]?.mentalHealthStatus ===
                  "NEED_HELP" && (
                  <Flex justifyContent={"flex-start"} alignItems={"center"}>
                    <Text fontSize={27}>😥</Text> I am not doing well and need
                    help/support
                  </Flex>
                )}
              </Flex>
            )}
        </Grid>
      </Flex>
    </Card>
  );
}
